import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en';
import ar from './locales/ar';

const storedLanguage = localStorage.getItem('language') || 'EN';

i18next
  .use(initReactI18next)
  .init({
    resources: {
      EN: {
        translation: en
      },
      AR: {
        translation: ar
      }
    },
    lng: storedLanguage, // Use stored language or default to EN
    fallbackLng: 'EN',
    interpolation: {
      escapeValue: false
    }
  });

export default i18next;